var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchangeMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M254,374v20c-26,0-50.8-7.2-71.6-20H254z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 254,
    cy: 254,
    r: 100
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 254,
    cy: 254,
    r: 78
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.2,273.6c0-15.2-12.4-27.2-27.2-27.2c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6 c3.2,0,6.4,1.2,8.4,3.6c2.8,3.2,8,3.2,11.2,0.4s3.2-8,0.4-11.2c-3.2-3.6-7.6-6-12-7.6v-5.6c0-4.4-3.6-8-8-8s-8,3.6-8,8v5.6 c-11.2,3.2-19.6,14-19.6,26c0,15.2,12.4,27.2,27.2,27.2c6.4,0,11.6,5.2,11.6,11.6s-5.2,11.6-11.6,11.6c-3.2,0-6.4-1.2-8.4-3.6 c-2.8-3.2-8-3.2-11.2-0.4c-3.2,2.8-3.2,8-0.4,11.2c3.2,3.6,7.6,6,12,7.6v5.6c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8v-5.6 C273.2,296.4,281.2,286,281.2,273.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M393.6,254c0,37.2-14.4,72.4-40.8,98.8c-26.4,26.4-61.6,40.8-98.8,40.8H113.6l17.2,17.2 c4,4,4,10,0,14c-2,2-4.4,2.8-7.2,2.8c-2.4,0-5.2-0.8-7.2-2.8l-34-34c-4-4-4-10,0-14l34-34c4-4,10-4,14,0s4,10,0,14L113.6,374H254 c32,0,62-12.4,84.8-35.2C361.2,316,374,286,374,254c0-66-53.6-120-120-120h71.6C366.4,158.8,393.6,203.2,393.6,254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M425.2,131.2l-34,34c-2,2-4.4,2.8-7.2,2.8c-2.4,0-5.2-0.8-7.2-2.8c-4-4-4-10,0-14L394,134H254 c-66,0-120,53.6-120,120c0,66,53.6,120,120,120h-71.6c-40.8-24.4-68-69.2-68-120c0-77.2,62.8-139.6,139.6-139.6h140.4l-17.2-17.2 c-4-4-4-10,0-14s10-4,14,0l34,34C429.2,121.2,429.2,127.2,425.2,131.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeMoney);
export default __webpack_public_path__ + "static/media/exchange-money.43cb41c17432a47ad4807fd7e5186a3a.svg";
export { ForwardRef as ReactComponent };